import React, { useEffect } from "react";
import GalleryComp from "../../Components/Gallery/GalleryComp";
import { useDispatch, useSelector } from "react-redux";
import { getGallery } from "../../Redux/Slices/AppSlices";
import Loader from "../../Components/Loader/Loader";

const Gallery = () => {
  const dispatch = useDispatch();
  const { gallery, loading } = useSelector((state) => state.app);

  useEffect(() => {
    dispatch(getGallery());
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="admission-page">
      <GalleryComp showCategories={true} gallery={gallery} />
    </div>
  );
};

export default Gallery;
